







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DailyLoadProcessStatus } from '@/api/dashboard/DailyLoadProcessStatus';
import { DailyLoadProcessStatuses } from '@/api/dashboard/DailyLoadProcessStatuses';

@Component({})
export default class DailyLoadProcessStatusIndicator extends Vue {
  @Prop() processStatus!: DailyLoadProcessStatus;

  statusText() {
    return !this.processStatus ? '' : DailyLoadProcessStatuses.get(this.processStatus);
  }

  statusColor() {
    switch (this.processStatus) {
      case DailyLoadProcessStatus.COMPLETED:
        return 'primary';
      case DailyLoadProcessStatus.FAILED:
        return 'error darken-1';
      default:
        return 'normal';
    }
  }

  statusTextColor() {
    switch (this.processStatus) {
      case DailyLoadProcessStatus.COMPLETED:
      case DailyLoadProcessStatus.FAILED:
        return 'white';
      default:
        return 'normal';
    }
  }
}
